<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    label: { type: String },
    chartData: { type: Array },
    options: { type: Object },
  },
  computed: {
    participantsLocal: function() {
      return this.chartData.map((d) => d.participants);
    },
  },
  watch: {
    participantsLocal: function() {
      this.renderLineChart();
    },
  },
  mounted() {
    this.renderLineChart();
  },
  methods: {
    renderLineChart: function() {
      const dates = this.chartData.map((d) => d.date);
      const participants = this.chartData.map((d) => d.participants);
      const totals = [];
      if (
        participants &&
        participants[0] instanceof Array &&
        participants[0].length
      ) {
        for (let i = 0; i < participants.length; i++) {
          totals.push(participants[i][0]);
        }
      } else {
        for (let i = 0; i < participants.length; i++) {
          totals.push(participants[i]);
        }
      }
      this.renderChart(
        {
          labels: dates,
          datasets: [
            {
              label: this.label,
              data: totals,
              borderColor: "#ffffff",
              borderWidth: 0.5,
              backgroundColor: "#64a0c8",
            },
          ],
        },
        this.options
      );
    },
  },
};
</script>

<style scoped></style>
